/**
 * Use React Query on the product page
 * Product Area: WEB_SERVER_SIDE_RENDERING
 */
export const PRODUCT_PAGE_REACT_QUERY_241007 = 'PRODUCT_PAGE_REACT_QUERY_241007';
